<template>
  <div
    class="modal"
    style="z-index: 110"
    :style="{
      display: active ? 'block' : 'none',
      padding: '12px',
      marginTop: '20px',
      marginLeft: sideBarMinimized ? '0px' : '100px',
    }"
  >
    <div class="modal-dialog modal-lg" style="max-width: 500px, height: '100%'">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">
            <slot name="title"></slot>
          </h4>
          <button type="button" class="close" @click="close()">×</button>
        </div>
        <div class="modal-body" style="max-height: 450px; overflow: auto">
          <slot></slot>
        </div>
        <div class="modal-footer">
          <slot name="footer"> </slot>
          <button type="button" class="btn btn-info" @click="close()">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  props: {
    active: Boolean,
    modalHeight: {
      type: String,
      default: "auto",
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
  computed: {
    ...mapState({
      sideBarMinimized: (state) => state.appStore.sideBarMinimized,
    }),
  },
};
</script>
<style>
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  overflow: auto;
  outline: 0;
}
.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1 px solid rgba(0, 0, 0, 0.2);
  border-radius: 30px !important;
  outline: 0;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/Modal.vue